import { render } from "./BusinessProtectionAnalysis.vue?vue&type=template&id=14cd572a&scoped=true"
import script from "./BusinessProtectionAnalysis.vue?vue&type=script&lang=js"
export * from "./BusinessProtectionAnalysis.vue?vue&type=script&lang=js"

import "./BusinessProtectionAnalysis.vue?vue&type=style&index=0&id=14cd572a&lang=css"
import "./BusinessProtectionAnalysis.vue?vue&type=style&index=1&id=14cd572a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cd572a"]])

export default __exports__